module.exports = function() {
  return new Worker(__webpack_public_path__ + "1c2cf35cb673bcbe03a0.worker.js");
};